// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__1qpT2","withoutPadding":"styles_withoutPadding__1w2zm","sectionText":"styles_sectionText__2scEw"};